import React from 'react';
import PaymentsTable from '../../payments/table/PaymentsTable';
import { PaymentListDataContext } from '../../payments/PaymentListDataContext';
import PaginationProvider from '../../../components/table/PaginationContext';

export default function PaymentsTab() {
  return (
    <PaymentListDataContext.Consumer>
      {({ currentPage, pageSize, page }) => (
        <>
          <PaginationProvider
            pageSizeOptions={[5, 10, 30]}
            currentPage={currentPage.get}
            totalPages={page?.totalPages || 0}
            pageSize={pageSize.get}
            setCurrentPage={currentPage.set}
            changePageSize={pageSize.set}
          >
            <PaymentsTable showPagination={true} />
          </PaginationProvider>
        </>
      )}
    </PaymentListDataContext.Consumer>
  );
}
